import { IDigitalHealthProfile } from '../components/UI/SelectedSalesOrder/DigitalHealthProfileTab';
import { authorizeClient } from '../networking/client';
import lamejs from 'lamejs';

export const findProductWithTaIdAndTransactionId = async (
  selectedSalesOrder: any
): Promise<IDigitalHealthProfile | undefined> => {
  let productFound;
  try {
    if (selectedSalesOrder?.customer_person.person_account_number) {
      const response: any = await authorizeClient.get(
        `/core/healthpoint/customer/${selectedSalesOrder?.customer_person.person_account_number}/product_orders?product_order_id=${selectedSalesOrder?.sales_order.sales_order_external_id}&product_order_item_id=${selectedSalesOrder?.sales_order_item.external_sales_order_item_id}&customer_ta_id=${selectedSalesOrder?.sales_order.ta_id}`
      );
      if (response.data && response.data.length > 0) {
        productFound = response?.data.find(
          (data: IDigitalHealthProfile) =>
            data.ta_id === selectedSalesOrder?.sales_order.ta_id &&
            data.transaction_id === selectedSalesOrder.sales_order.transaction_id &&
            data.product_order_item_id_out ===
              selectedSalesOrder.sales_order_item.external_sales_order_item_id
        );
      }
      return productFound;
    }
  } catch (err) {
    console.log(err);
    return productFound;
  }
};

export const getFullNameInitials = (customerFullName: string) => {
  let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
  let initials = [...customerFullName.matchAll(rgx)] || [];
  const res = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
  return res;
};

export const WebMToMP3Converter = async (webmBlob: any) => {
  // const convertWebMToMP3 = async () => {
  // Create a new AudioContext instance
  const audioContext = new AudioContext();

  // Decode the WebM blob to an audio buffer
  const arrayBuffer = await webmBlob.arrayBuffer();
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

  // Initialize the LAME.js encoder
  const mp3Encoder = new lamejs.Mp3Encoder(
    audioBuffer.numberOfChannels,
    audioBuffer.sampleRate,
    128
  );

  // Get left and right channel data
  const leftChannelData = audioBuffer.getChannelData(0);
  const rightChannelData = audioBuffer.numberOfChannels > 1 ? audioBuffer.getChannelData(1) : [];
  // The transformed data, this is what you will pass to lame instead
  // If you are sure to use a Float32Array you can skip this and use [left, right] const.
  const l = new Float32Array(leftChannelData.length);
  const r = new Float32Array(rightChannelData.length);

  //Convert to required format
  for (let i = 0; i < leftChannelData.length; i++) {
    l[i] = leftChannelData[i] * 32767.5;
    r[i] = rightChannelData[i] * 32767.5;
  }

  // Create an MP3 data array
  const mp3Data = [];

  const chunkSize = 1152; // LAME.js processes 1152 samples at a time

  for (var i = 0; i < l.length; i += chunkSize) {
    const leftChunk = l.subarray(i, i + chunkSize);
    const rightChunk = r.subarray(i, i + chunkSize);

    const mp3buf = mp3Encoder.encodeBuffer(leftChunk, rightChunk);

    if (mp3buf.length > 0) {
      mp3Data.push(mp3buf);
    }
  }

  // Flush remaining data
  const mp3Flush = mp3Encoder.flush();
  if (mp3Flush.length > 0) {
    mp3Data.push(new Int8Array(mp3Flush));
  }

  // Concatenate all the MP3 data into a Blob
  const mp3Blob = new Blob(mp3Data, { type: 'audio/mpeg' });

  // Close the AudioContext
  await audioContext.close();
  return mp3Blob;
};

export const mainHostUrl = (postFix: string) => {
  return window.location.origin + postFix;
};

export const generateQueryParams = (params: any) => {
  const queryObj: any = params;

  Object.keys(queryObj).forEach((key: string) => {
    queryObj[key] === undefined ? delete queryObj[key] : void 0;
  });

  const queryPrams = new URLSearchParams(queryObj).toString();
  return queryPrams.length > 0 ? `?${queryPrams}` : '';
};
